import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import {GlobalConstants} from "../data/GlobalConstants";

const alertQuestionSubject = new Subject();
const defaultId = 'defaultAlertQuestion';

export const alertQuestionService = {
    onAlertQuestion,
    showAlert,
    alertQuestion,
    clear
};


function onAlertQuestion(id = defaultId) {
    return alertQuestionSubject.asObservable().pipe(filter(x => x && x.id === id));
}

function showAlert({title, question, message, html, actionBtnAceptar, actionBtnCancelar, labelAceptar, labelCancelar, type = GlobalConstants.alertInfo,
                     close = true, targetPrecios, datos}) {
    alertQuestion({ type, title, question, message, html, actionBtnAceptar, actionBtnCancelar,
      labelAceptar, labelCancelar, close, targetPrecios, datos});
}

function alertQuestion(alertQuestion) {
    alertQuestion.id = alertQuestion.id || defaultId;
    alertQuestionSubject.next(alertQuestion);
}

function clear(id = defaultId) {
    alertQuestionSubject.next({ id });
}
